module.exports = __webpack_public_path__ + "47ebe900be293aae5c456d7aab6f7df1.MP3";